import { render, staticRenderFns } from "./technician-turnover.vue?vue&type=template&id=bd72bb4e&scoped=true&"
import script from "./technician-turnover.vue?vue&type=script&lang=js&"
export * from "./technician-turnover.vue?vue&type=script&lang=js&"
import style0 from "./technician-turnover.vue?vue&type=style&index=0&id=bd72bb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd72bb4e",
  null
  
)

export default component.exports